import apiService from './api';
import analyticsService from './analyticsService';

const adminService = {
  // Dashboard Summary
  async getDashboardSummary() {
    const response = await apiService.get('/admin/dashboard/summary/');
    console.log('AdminService - getDashboardSummary response:', response);
    return response;
  },
  
  // Daily Analytics
  async getDailyAnalytics(options = {}) {
    const normalizedOptions = typeof options === 'number' ? { days: options } : (options || {});
    const { days, month, year, startDate, endDate } = normalizedOptions;
    const params = new URLSearchParams();

    if (days != null) params.append('days', days);
    if (month != null) params.append('month', month);
    if (year != null) params.append('year', year);
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);

    const queryString = params.toString();
    const url = `/admin/daily-analytics/${queryString ? `?${queryString}` : ''}`;

    console.log('AdminService - getDailyAnalytics called with options:', normalizedOptions);
    
    try {
      // Use the corrected /admin/daily-analytics/ endpoint directly
      const response = await apiService.get(url);
      console.log('AdminService - getDailyAnalytics response:', response);
      
      // Handle both paginated and direct array responses
      if (response && response.results && Array.isArray(response.results)) {
        return response.results;
      } else if (Array.isArray(response)) {
        return response;
      } else {
        console.warn('AdminService - Unexpected response format:', response);
        return [];
      }
    } catch (error) {
      console.error('AdminService - Error fetching daily analytics:', error);
      
      // Fallback to analytics service if main endpoint fails
      console.log('AdminService - Falling back to analyticsService...');
      const fallbackResponse = await analyticsService.getDailyAnalytics(normalizedOptions);
      return fallbackResponse.results || [];
    }
  },
  
  // User Accounts
  async getUserAccounts(filters = {}) {
    const params = new URLSearchParams();
    if (filters.month) params.append('month', filters.month);
    if (filters.year) params.append('year', filters.year);
    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);
    if (filters.order_by) params.append('order_by', filters.order_by);
    if (filters.page) params.append('page', filters.page);
    
    return await apiService.get(`/admin/user-accounts/?${params}`);
  },

  // User finance summary for admin detail modal
  async getUserFinanceSummary(userId, filters = {}) {
    const params = new URLSearchParams();
    if (filters.month != null) params.append('month', filters.month);
    if (filters.year) params.append('year', filters.year);

    const queryString = params.toString();
    return await apiService.get(`/admin/users/${userId}/finance-summary/${queryString ? `?${queryString}` : ''}`);
  },

  // Monthly Analytics
  async getMonthlyAnalytics(year) {
    // Use the new analytics service that works with available endpoints
    return await analyticsService.getMonthlyAnalytics(year);
  },
  
  // Inactive Accounts
  async getInactiveAccounts(page = 1) {
    return await apiService.get(`/admin/accounts/inactive/?page=${page}`);
  },
  
  // Export Data
  async exportData(type, format, month, year) {
    const params = new URLSearchParams();
    if (format) params.append('format', format);
    if (month) params.append('month', month);
    if (year) params.append('year', year);
    
    // For CSV/XLSX, we need special handling
    if (format === 'csv' || format === 'xlsx') {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'https://api.dale365.com/api/v1';
      const response = await fetch(`${baseUrl}/admin/export/${type}/?${params}`, {
        headers: apiService.getHeaders()
      });
      return response.blob();
    }
    
    return await apiService.get(`/admin/export/${type}/?${params}`);
  },
  
  // Get users with movement on a specific date
  async getUsersWithMovement(date) {
    const response = await apiService.get(`/admin/users-movement/${date}/`);
    console.log('AdminService - getUsersWithMovement response:', response);
    return response;
  }
};

export default adminService;
